import React, { useEffect, useLayoutEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { logout } from '../../../app/shared/reducers/authentication';

export const Logout = () => {
  const logoutUrl = useAppSelector(state => state.authentication.logoutUrl);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (logoutUrl) {
      setTimeout(() => {
        localStorage.clear();
        window.location.href = logoutUrl;
      }, 500);
    } else {
      window.location.href = 'oauth2/authorization/oidc';
    }
  }, [logoutUrl]);

  return <></>;
};

export default Logout;
